var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drawers",class:( _obj = {}, _obj[_vm.position_] = true, _obj.active = _vm.open_, _obj )},[_c('div',{ref:"mask",staticClass:"drawers-mask",on:{"click":_vm.handleMaskTap}}),_vm._v(" "),_c('div',{ref:"container",staticClass:"drawers-container",class:{active: _vm.open_ },style:({ transform: _vm.initTransform })},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d100b7e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Drawer.vue
// module id = null
// module chunks = 